export const toast = {       
    defaultProps:{
        position: 'top',
        status: 'error'
    }
}